import { FC, ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { clearSkyddsklassning, deleteSkyddsklassning } from 'store/aktivitetSlice';
import { RootState } from 'store/rootReducer';

import { useAppDispatch, useAppSelector } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';

import { RaaDialog } from 'raa-react';

import { ModelError, Skyddsklassningsaktivitet } from 'models';

const DeleteSkyddsklassningDialog: FC<{
  skyddsklassning?: Skyddsklassningsaktivitet;
  eTag?: string;
}> = ({ eTag, skyddsklassning }): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { unsetDialog } = useDialog();
  const { requestStatus } = useAppSelector((state: RootState) => state.aktivitet);
  const [error, setError] = useState<string>();

  const handleDelete = async (skyddsklassning: Skyddsklassningsaktivitet): Promise<void> => {
    const response = await dispatch(deleteSkyddsklassning({ aktivitetId: skyddsklassning.aktivitet_id, eTag }));
    if (response.meta.requestStatus === 'fulfilled') {
      dispatch(clearSkyddsklassning());
      navigate('/', { replace: true });
      unsetDialog();
    } else {
      setError((response.payload as ModelError).message);
    }
  };

  return (
    <RaaDialog
      cancel={unsetDialog}
      cancelButtonText={error ? 'stäng' : 'avbryt'}
      close={unsetDialog}
      header={error ? 'Något gick fel!' : `Vill du radera ${skyddsklassning?.skyddsklassningstyp_namn.toLowerCase()}?`}
      proceed={error ? undefined : () => handleDelete(skyddsklassning!)}
      proceedButtonText="radera"
      showLoadingSpinner={requestStatus === 'pending'}
      ariaDescribedBy="dialog-description"
    >
      {error && (
        <p id="dialog-description" className="tw-mt-8">
          {error}
        </p>
      )}
    </RaaDialog>
  );
};

export default DeleteSkyddsklassningDialog;
